//  <FileHeader xmlns="http://www.gordic.cz/shared/file-header/v_1.0.0.0">
//    <Name>        Gordic.Epk.WebControls.ZadostSchvalCertifikat.ts			</Name>
//    <Description> Dialog žádosti o schválení certifikátu						</Description>
//    <Author>      thazmuka													</Author>
//    <Copyright>   © GORDIC spol. s r. o. 1993-2018							</Copyright>
//    <Created>     2018-10-10													</Created>
//  </FileHeader>

namespace Gordic.Epk.WebControls {

	/**
	 * Validní certifikát pro podepisování (DTO)
	 */
	interface EpkValidCertificateForSigningDto {
		/**
		 * viditelnost
		 */
		Visible: boolean,
		/**
		 * text zprávy
		 */
		Text: string
    }

    interface ISeznamNavazanychCertifikatu {
        jmeno: string,
        dat_od: Date,
        dat_do: Date,
        aktivita: number
    }

	const { gcontent } = Decorators;

	/**
	 * Žádost o schválení certifikátu
	 *
	 * @author thazmuka
	 * @since 480.1.0.33
	 */
	@gcontent
    export class GEpkRequestForCert extends GContentBase {

		/** Text žádosti o schválení certifikátu pro podepisování */
		private TextToApproveSigningCertificate: string;
		/** Validní certifikát pro podepisování */
		private EpkValidCertificateForSigning: EpkValidCertificateForSigningDto;
        /** zpráva */
        private AlertMessage?: string;
        /** řádky do seznamu podaných certifikátů */
        private rows: ISeznamNavazanychCertifikatu[]; 

        private grid: JQuery<HTMLElement>;
        private searchColumns: string[];
        private elementGTab: JQuery<HTMLElement>;

		/**
		 * onContentReady
		 */
        public onContentReady() {
			this.init();
		}

        private flashAlertId = "IdAlertMessage";
        private flashCertId = "IdZadostSchvalCertifikat";

		/**
		 * init
		 */
        private init() {
			

			this.createForm();
			this.createMenuBar();
            this.unSelectFocusAndText("obsah-soubor-podpis-class");

            if (this.AlertMessage !== undefined) {
                this.showFlash({
                    content: this.AlertMessage,
                    state: "warning",
                    id: this.flashAlertId
                });
            }

            this.createGTab();

		}

        private createGTab() {

            this.elementGTab = $("<div>").appendTo(this.element);

            let form = $("<div>").appendTo(this.elementGTab);
            let Form = new Gordic.Forms.Form({
                name: "FormZadostSchvalPodpis"
            });

            Form.addSection("jres:32000398");    //RC 32000398 : Přiřazené certifikáty
            form.gform("createFrom", Form);

            this.createGrid();

        }

        private createGrid() {

            var format = this.createGridFormat();
            this.grid = $("<div>").gautofit().appendTo(this.elementGTab);

            this.grid.ggrid({
                name: "EpkReqCertGrid",
                data: this.rows,
                renderMode: "auto",
                columnMode: "full",
                navigationMode: "row",
                columns: format,
                searchColumns: this.searchColumns,
                rowsEnabled: (metarow: any) => {
                    return metarow.data.aktivita !== 100 ? false : true;
                }
            })
        }

        private createGridFormat() {

            var format = new Gordic.Data.GridFormat<any>();

            format
                .addTextColumn({
                    name: "req",
                    cellTemplate: (data: ISeznamNavazanychCertifikatu) => {
                        var template = $("<div>");
                        if (data.aktivita === 300) {
                            return template.text("jres:32000004"); //RC 32000004 : Žádost
                        }
                        else {
                            return template;
                        }
                    },
                    caption: "jres:32000004", //RC 32000004 : Žádost
                    description: "jres:32000399", //RC 32000399 : Žádost o schválení certifikátu
                    width: 80
                })     

            format
                .addIconColumn({
                    name: "platnost",
                    caption: "jres:32000395", //RC 32000395 : Platnost
                    width: 30,
                    customClass: "center",
                    iconTemplate: (data: ISeznamNavazanychCertifikatu) => {

                        var dat_do = data.dat_do;
                        var now = new Date();
                        if (typeof data.dat_do === "string")
                            dat_do = Gordic.Utils.DateTime.parse(data.dat_do);

                        if (dat_do < now) {
                            // neplatný
                            return { icon: "gi-vyrizenopo_bold g-state-text g-state-error", tooltip: "jres:32000397" }; //RC 32000397 : Neplatný
                        }
                        else {
                            // platný
                            return { icon: "gi-vyrizenopred_bold g-state-text g-state-success", tooltip: "jres:32000396" }; //RC 32000396 : Platný
                        }
                    }
                })

            format
                .addTextColumn({
                    name: "jmeno",
                    caption: "jres:32000046", //RC 32000046 : Název
                    width: 200
                })
            format
                .addDateTimeColumn({
                    name: "dat_od",
                    caption: "jres:32000392", //RC 32000392 : Datum od
                    width: 200
                })
            format
                .addDateTimeColumn({
                    name: "dat_do",
                    caption: "jres:32000393", //RC 32000393 : Datum do
                    width: 200
                })

            this.setSearchColumns(format.columns);

            return format;
        }

        /**
          * nasetování sloupců pro prohledávání
          * @param columns sloupce
          */
        private setSearchColumns(columns) {
            this.searchColumns = [];
            for (var index = 0; index < columns.length; index++) {
                var name = columns[index].name;
                this.searchColumns.push(name);
            }
        }

		/**
		 * funkce provede odebrání focusu na políčku a vybrání textu na celém contentu
		 * - na fci je použit timeout, aby se stihl načíst content, než se provede odebrání (jinak není proveden)
		 */
		private unSelectFocusAndText(myclass: string) {

            var getSelection = window.getSelection();

            if (getSelection === null) {
                // nic
            }
            else {
			setTimeout(() => {
                    (getSelection as Selection).removeAllRanges();
				$("." + myclass).blur();
			}, 1);
		}

		}

		/**
		 * createForm
		 */
		private createForm(): void {

			let form = $("<div>").appendTo(this.element);
			let Form = new Gordic.Forms.Form({
				name: "FormZadostSchvalPodpis"
			});

			Form.addSection("jres:32000499") //RC 32000499 : Informace

			if (this.EpkValidCertificateForSigning.Visible === true) {
				Form.addText(this.EpkValidCertificateForSigning.Text);
			}

			Form.addText("jres:32000147") //RC 32000147 : Pokud chcete provádět úkony podpisu vybraným certifikátem, je třeba podepsat a odeslat žádost o schválení elektronického podpisu pro potřeby APV GINIS.
			Form.addText("jres:32000148") //RC 32000148 : Podepsáním se zároveň žádost odešle.

			Form
				.addSection()

			Form
				.addRow("jres:32000145")			//RC 32000145 : Obsah souboru k podpisu
				.addField("gstringbox", {
					name: "obsah-soubor-podpis",
					disabled: true,
					rows: 7,
					initialValue: this.TextToApproveSigningCertificate,
					customClass: "obsah-soubor-podpis-class"
				})

			form.gform("createFrom", Form);

		}

		/**
		 * createMenuBar
		 */
		private createMenuBar(): void {
			const menuBar: MenuParams[] = [];
			menuBar.push({								// definice tlačítka Detail
				favorite: true,
				action: this.actions.add(new GAction({
					name: "actPodepsat",
					customClass: "podepsat-class",
					icon: "fa-check-circle g-state-text g-state-success",
					caption: "jres:26265056",			//RC 26265056 : Podepsat
                    run: () => {
                        if (this.closed === true)
                            return;
						this.generatePreview();
					}
				}))
            });

            menuBar.push({								
                favorite: true,
                action: this.actions.add(new GAction({
                    name: "actRefresh",
                    customClass: "refresh-class",
                    icon: "gi-refresh",
                    caption: "jres:32000022",			//RC 32000022 : Občerstvit
                    tooltip: "jres:32000498",			//RC 32000498 : Občerstvit seznam
                    run: () => {
                        this.refreshGrid();
                    }
                }))
            });

			this.menuBar(menuBar);
        }

        private refreshGrid() {
            this.call("GetData")
                .done((rows: ISeznamNavazanychCertifikatu[]) => {
                    this.grid.ggrid("setData", rows);
            }   );
        }

        private generatePreview() {

            this.hideFlash(this.flashAlertId);
            this.hideFlash(this.flashCertId);

			this.beginOperation("jres:32000156"); //RC 32000156 : Probíhá podepisování souboru.

            //#region -- loadConfigDelegate --

            var loadConfigDelegate: TBeforeSignDelegate = (configDto: GSignMinimumConfig, customDto?: IGCustomDto): JQueryPromise<GSignCreateConfig> => {
				$.extend(true, configDto, { signTime: new Date(), saveToStorage: true });
				return this.call("GeneratePdfForCertificateApproval", { configDto: configDto });
            };

            //#endregion

            //#region -- signReasonDelegate --

			var signReasonDelegate = () => {
				return $.Deferred().resolve({} as Wfl.Client.GSignPreConfigDto).promise();
			};

            //#endregion

            return new Gordic.Wfl.WebClient.GWflClientSigner(null, {}, signReasonDelegate, $.noop(), $.noop(), loadConfigDelegate)
                .sign({ fileName: "" }, { cardView: true })
                .then((signedConfig) => {
                    if (this.closed === true) 
                        return $.Deferred().reject().promise();
                    this.progressOperation("jres:32000155") //RC 32000155 : Probíhá vkládání žádosti o schválení certifikátu.
                    return this.call("VlozitZadostOSchvaleni", { config: signedConfig });
                })
                .then(() => {
                    this.endOperation();
                    this.showFlash({
                        content: "jres:32000192", //RC 32000192 : Žádost o schválení certifikátu byla předána.
                        state: "success",
                        id: this.flashCertId
                    });
                    if (this.closed === true)
                        return;
                    this.refreshGrid();
                }, (reason) => {
                    if (reason == null)
                        return $.Deferred().reject().promise();
                    else {
                        Gordic.Gui.WebApp.Utils.showReasonFlash(this, reason);
                        return $.Deferred().reject(reason.reason).promise();
                    }
                })
                .fail((message) => {
                    this.endOperation();
                    if (this.closed === true)
                        return;
                    //c.handled = true;
                    this.showFlash({
                        content: message,
                        state: "error",
                        id: this.flashCertId
                    });
                })


		}

	}

}